import * as React from 'react'
import './index.scss'
import {CHAINTYPES, ROLES, SOCKET_STATUS, storeType, userInfoType} from "../../reducers/types";
import Select from "@material-ui/core/Select";
import {MyInput, MyMenuItem} from "../CustomUIComp/CustomFormElem";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import ChangePasswordModal from '../ChangePasswordModal';
import merchantIcon from '../../images/merchant.svg';
import {injectIntl, IntlShape} from "react-intl";

interface IProps {
    userInfo: userInfoType | undefined,
    storeList: storeType[],
    onStoreChange: (value: any) => void,
    currentStore: number,
    chainType: CHAINTYPES,
    onLogout: () => void,
    socketStatus: SOCKET_STATUS,
    role: ROLES,
    intl: IntlShape,
    onGetStoreList: () => void
}

interface IState {
    anchorEl: HTMLElement | null,
    changePasswordModal: boolean
}


class TopBar extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            anchorEl: null,
            changePasswordModal: false
        }
    }

    componentDidMount() {
        if (this.props.chainType === CHAINTYPES.CHAIN_STORE && this.props.role === ROLES.SUPER_ADMIN) {
            // 连锁店并且是超级管理员才可以获取店铺列表
            this.props.onGetStoreList()
        }
    }

    componentDidUpdate(prevProps: IProps) {
        // console.log('topbar did update:', prevProps.role, this.props.role, this.props.chainType)
        if (this.props.role === ROLES.SUPER_ADMIN &&
            this.props.chainType === CHAINTYPES.CHAIN_STORE &&
            (this.props.role !== prevProps.role || this.props.chainType !== prevProps.chainType)
        ) {
            this.props.onGetStoreList()
        }
    }


    handleStoreChange = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
        this.props.onStoreChange(event.target.value)
    }
    handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        this.setState({
            anchorEl: event.currentTarget
        })
    }
    handleClose = () => {
        this.setState({
            anchorEl: null
        })
    }
    closePasswordModal = () => {
        this.setState({
            changePasswordModal: false
        })
    }
    modifyPassword = () => {
        this.handleClose()
        this.setState({
            changePasswordModal: true
        })
    }
    logout = () => {
        this.handleClose()
        this.props.onLogout()
    }

    public render() {
        let storeName = '', userName = '', role = ROLES.NONE
        if (this.props.userInfo) {
            storeName = this.props.userInfo.storeName
            userName = this.props.userInfo.name || this.props.userInfo.email
            role = this.props.userInfo.role
        }
        const open = Boolean(this.state.anchorEl);
        let {intl} = this.props
        return (
            <div className="topBar">
                <div className="contentWrapper">
                    <div>
                        <span className="merchantLogo">
                            <img src={merchantIcon} alt="merchant logo"/>
                        </span>
                        {this.props.chainType === CHAINTYPES.CHAIN_STORE && role === ROLES.SUPER_ADMIN ?
                            <Select
                                value={this.props.currentStore}
                                onChange={this.handleStoreChange}
                                input={<MyInput id="store-select"
                                                fontSize={14}
                                                fontWeight={600}
                                                name="storeId"
                                                border="none"/>}>
                                <MyMenuItem value={-1}>{intl.formatMessage({id: 'allStore'})}</MyMenuItem>
                                {
                                    this.props.storeList.map((store, i) => {
                                        return <MyMenuItem key={`${store.storeId}`}
                                                           value={store.storeId}>{store.storeName}</MyMenuItem>
                                    })
                                }
                            </Select> : <span className="storeName">{storeName}</span>}
                        {this.props.socketStatus === SOCKET_STATUS.CONNECTED ?
                            <span
                                className="socketStatus online">{intl.formatMessage({id: SOCKET_STATUS.CONNECTED})}</span> :
                            <span
                                className="socketStatus offline">{intl.formatMessage({id: SOCKET_STATUS.DISCONNECT})}</span>}
                    </div>
                    <div>
                        <Button aria-controls="user-menu"
                                aria-haspopup="true"
                                className="userNameButton"
                                onClick={this.handleClick}>
                            <span className="icon icon-user"></span>
                            <span>{userName}</span>
                            <span className="icon icon-arrow"></span>
                        </Button>
                        <Menu
                            id="user-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={open}
                            onClose={this.handleClose}
                        >
                            <MenuItem onClick={this.modifyPassword}>{intl.formatMessage({id: 'modifyPass'})}</MenuItem>
                            <MenuItem onClick={this.logout}>{intl.formatMessage({id: 'logout'})}</MenuItem>
                        </Menu>
                    </div>
                </div>
                <CustomDialog open={this.state.changePasswordModal}
                              title={intl.formatMessage({id: 'modifyPass'})}
                              showActions={false}
                              content={<ChangePasswordModal handleClose={this.closePasswordModal}/>}
                              handleClose={this.closePasswordModal}/>
            </div>
        );
    }
}

export default injectIntl(TopBar)